import { LitElement, html, css, nothing } from 'lit';
import '@brightspace-ui/core/components/colors/colors.js';

class JwtDecoderComponent extends LitElement {
  static properties = {
    jwt: { type: String },
    decodedPayload: { type: Object },
    errorMessage: { type: String },
  };

  static styles = css`
    :host {
      display: block;
    }

    .error {
      color: var(--d2l-color-cinnabar);
    }

    .decoded {
      white-space: pre-wrap;
      word-break: break-word;
      background-color: var(--d2l-color-ferrite);
      color: var(--d2l-color-sylvite);
      padding: 15px;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    .token {
      margin-top: 20px;
    }
  `;

  constructor() {
    super();
    this.jwt = '';
    this.decodedPayload = null;
    this.errorMessage = '';
  }

  updated(changedProperties) {
    if (changedProperties.has('jwt')) {
      this.decodeJwt();
    }
  }

  decodeJwt() {
    this.errorMessage = '';
    this.decodedPayload = null;

    if (!this.jwt) return;

    try {
      const [header, payload, signature] = this.jwt.split('.');
      if (!header || !payload || !signature) {
        throw new Error('Invalid JWT format');
      }

      const decodedPayload = JSON.parse(atob(payload));

      // Convert issued at and expiry times to local timezone
      if (decodedPayload.iat) {
        decodedPayload.iatLocal = new Date(decodedPayload.iat * 1000).toLocaleString();
      }
      if (decodedPayload.exp) {
        decodedPayload.expLocal = new Date(decodedPayload.exp * 1000).toLocaleString();
      }

      this.decodedPayload = decodedPayload;
    } catch (error) {
      this.errorMessage = error.message || 'Failed to decode JWT';
    }
  }

  render() {
    if (!this.decodedPayload) return nothing;

    return html`
      <div>
        ${this.errorMessage ? html`<p class="error d2l-body-small">${this.errorMessage}</p>` : nothing}

        <div class="token">
          <h3 class="d2l-body-small">Decoded Payload</h3>
          <div class="decoded d2l-body-small">
            ${JSON.stringify(this.decodedPayload, null, 2)}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('jwt-decoder', JwtDecoderComponent);
